import React, { useState } from 'react';
import { ui } from './toolTheme';
const API_BASE = process.env.REACT_APP_API_BASE || '';

const dl = async (url, fd, name) => {
  const res = await fetch(url, { method:'POST', body: fd });
  if (!res.ok) throw new Error((await res.json().catch(()=>({}))).error || 'Failed');
  const blob = await res.blob(); const u = URL.createObjectURL(blob); const a = document.createElement('a'); a.href = u; a.download = name; a.click(); URL.revokeObjectURL(u);
};

const ZipUnzipPage = ({ setPage }) => {
  const [files, setFiles] = useState([]);
  const [zip, setZip] = useState(null);
  const [err, setErr] = useState('');

  return <main style={ui.page}><div style={{...ui.container, maxWidth:860}}>
    <button onClick={()=>setPage('/tools')} style={ui.backBtn}>← Back to Tools</button>
    <div style={ui.card}><h1 style={ui.sectionTitle}>ZIP / UNZIP Tool</h1></div>
    <div style={{...ui.card, marginTop:14}}>
      <h3 style={{color:'#cbd5e1'}}>Create ZIP</h3>
      <div style={{display:'flex', gap:10}}>
      <input type='file' multiple onChange={(e)=>setFiles(Array.from(e.target.files||[]))} style={ui.fileInput} />
      <button onClick={async()=>{ setErr(''); try { const fd=new FormData(); files.forEach(f=>fd.append('files', f)); await dl(`${API_BASE}/api/file/zip`, fd, 'archive.zip'); } catch(e){ setErr(e.message);} }} style={ui.primaryBtn}>Zip Files</button>
      </div>
    </div>
    <div style={{...ui.card, marginTop:14}}>
      <h3 style={{color:'#cbd5e1'}}>Extract ZIP</h3>
      <div style={{display:'flex', gap:10}}>
      <input type='file' accept='.zip' onChange={(e)=>setZip(e.target.files?.[0]||null)} style={ui.fileInput} />
      <button onClick={async()=>{ setErr(''); try { if(!zip) return; const fd=new FormData(); fd.append('file', zip); await dl(`${API_BASE}/api/file/unzip`, fd, 'unzipped_files.zip'); } catch(e){ setErr(e.message);} }} style={ui.primaryBtn}>Unzip</button>
      </div>
      {err && <div style={ui.error}>{err}</div>}
    </div>
  </div></main>;
};

export default ZipUnzipPage;
